import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchState = (params) => {
  return apiBase({
    url: `/cats/states`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreState = (params) => {
  return apiBase({
    url: '/cats/states',
    method: 'post',
    data: params
  });
};

export const ShowState = ({ id }) => {
  return apiBase({
    url: `/cats/states/${id}`,
    method: 'get'
  });
};

export const UpdateState = (params) => {
  return apiBase({
    url: `/cats/states/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyState = ({ id }) => {
  return apiBase({
    url: `/cats/states/${id}`,
    method: 'delete'
  });
};
